<template>
  <TransitionGroup
    name="list" tag="div" class="toast" :class="positionClass">
    <div
      v-for="m in messages"
      class="toast-message"
      :class="messageTypeClass(m)"
      :key="m.id"
      role="note">
      <div class="toast-message-text" v-if="html" v-html="m.text"></div>
      <div class="toast-message-text" v-else>{{ m.text }}</div>
      <button
        class="toast-button"
        aria-label="Close"
        type="button"
        @click="close(m.id)" />
    </div>
  </TransitionGroup>
</template>

<script>
// Ported from https://github.com/ktsn/vuex-toast
import { REMOVE_TOAST_MESSAGE } from 'store/toast';

export default {
  name: 'q-toast',

  computed: {
    messages() {
      return this.$store.getters[`${this.normalizedNamespace}toastMessages`];
    },

    positionClass() {
      return `toast-position-${this.position}`;
    },

    normalizedNamespace() {
      if (this.namespace === '') {
        return '';
      }

      if (!/\/$/.test(this.namespace)) {
        return `${this.namespace}/`;
      }

      return this.namespace;
    },
  },

  methods: {
    close(id) {
      this.$store.dispatch(
        this.normalizedNamespace + REMOVE_TOAST_MESSAGE,
        id,
      );
    },

    messageTypeClass(message) {
      return `toast-type-${message.type}`;
    },
  },

  props: {
    position: {
      validator(value) {
        return /^(:?n|s|nw|ne|sw|se)$/.test(value);
      },
      default: 'ne',
    },

    namespace: {
      type: String,
      default: '',
    },

    html: Boolean,
  },
};
</script>

<style lang="scss" scoped>
$width: 350px;

.toast {
  position: fixed;
  width: $width;
  z-index: 10000;
}

.toast-message {
  position: relative;
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 15px;
  width: 100%;
  color: #fff;
  transition: 400ms cubic-bezier(0.17, 0.67, 0.17, 0.98);
  transition-property: opacity, transform;
}

.toast-button {
  position: absolute;
  top: 0;
  right: 5px;
  padding: 2px;
  background-color: transparent;
  border-width: 0;
  font-size: 1.5em;
  color: inherit;
  cursor: pointer;
}

.toast-button::before {
  content: '\d7';
}

/**
 * Transition
 */
.toast-enter-active,
.toast-leave {
  opacity: 1;
}

.toast-enter,
.toast-leave-active {
  opacity: 0;
}

.toast-leave-active {
  position: absolute;
}

/**
 * Position
 */
.toast-position-n {
  top: 10px;
  left: 50%;
  margin-left: -($width * 0.5);
}

.toast-position-s {
  bottom: 10px;
  left: 50%;
  margin-left: -($width * 0.5);
}

.toast-position-ne {
  top: 10px;
  right: 10px;
}

.toast-position-nw {
  top: 10px;
  left: 10px;
}

.toast-position-se {
  bottom: 10px;
  right: 10px;
}

.toast-position-sw {
  bottom: 10px;
  left: 10px;
}

/**
 * Transition with position
 */
.toast-position-n,
.toast-position-ne,
.toast-position-nw {
  .toast-enter,
  .toast-leave-active {
    transform: translateY(-20px);
  }
}

.toast-position-s,
.toast-position-se,
.toast-position-sw {
  .toast-enter {
    transform: translateY(20px);
  }

  .toast-leave-active {
    transform: translateY(-100%) translateY(20px);
  }
}

/**
 * Types
 */
.toast-type-info {
  background-color: #43b4ec;
}

.toast-type-success {
  background-color: #3add93;
}

.toast-type-warning {
  background-color: #efd700;
}

.toast-type-danger {
  background-color: #f3755e;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
